module.exports = __webpack_public_path__ + "static/media/refresh.427c2669.svg";